import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5df824f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("th", null, _toDisplayString(_ctx.userData.user_id), 1),
    (_ctx.userData.type != 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          _createElementVNode("figure", {
            class: "image is-64x64 pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
          }, [
            _createElementVNode("img", {
              class: "is-rounded",
              src: _ctx.userImageURL,
              alt: "click_to_upload"
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("input", {
            type: "file",
            class: "is-hidden",
            ref: "imageInput",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadImage(_ctx.$t)))
          }, null, 544)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.userData.name), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editedName) = $event)),
            class: "input"
          }, null, 512)), [
            [_vModelText, _ctx.editedName]
          ])
    ]),
    _createElementVNode("td", null, [
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.userData.email), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editedEmail) = $event)),
            class: "input"
          }, null, 512)), [
            [_vModelText, _ctx.editedEmail]
          ])
    ]),
    (_ctx.userData.type != 'manager')
      ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.userData.phone), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editedPhone) = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, _ctx.editedPhone]
              ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData.type == 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.userData.address), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editedAddress) = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, _ctx.editedAddress]
              ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData.type == 'vet')
      ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.userData.specialty), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editedSpecialty) = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, _ctx.editedSpecialty]
              ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData.type == 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.userData.tax_id), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editedTaxId) = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, _ctx.editedTaxId]
              ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", {
      class: _normalizeClass({ 'inactive-status': _ctx.userData.status === _ctx.$t('UserData.TK_Inactive') })
    }, [
      _createElementVNode("div", null, _toDisplayString(_ctx.userData.status), 1)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'inactive-status': _ctx.userData.status === _ctx.$t('UserData.TK_Inactive') })
    }, [
      _createElementVNode("div", null, _toDisplayString(_ctx.userData.status_date), 1)
    ], 2),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.userData.type != 'customer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (!_ctx.editing)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button is-warning is-small",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleEditing && _ctx.toggleEditing(...args))),
                    disabled: _ctx.userData.status === _ctx.$t('UserData.TK_Inactive')
                  }, _toDisplayString(_ctx.$t('General.Edit')), 9, _hoisted_15))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button is-success is-small",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save(_ctx.$t)))
                  }, _toDisplayString(_ctx.$t('General.Save')), 1))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.editing && _ctx.userData.type != 'customer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "button is-danger is-small",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.remove(_ctx.userData, _ctx.$t))),
                disabled: _ctx.userData.status === _ctx.$t('UserData.TK_Inactive')
              }, _toDisplayString(_ctx.$t('General.Deactivate')), 9, _hoisted_17)
            ]))
          : _createCommentVNode("", true),
        (_ctx.userData.type == 'customer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "button is-success is-small",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.parentShowCustomerData(_ctx.userData)))
              }, _toDisplayString(_ctx.$t('General.Details')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}